import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTA } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-6 pb-12 overflow-hidden" data-id="element-86">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-pink-200/40 blur-[100px] rounded-full pointer-events-none" data-id="element-87" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-88">
        <div className="flex justify-center mb-10" data-id="element-89">
          <span className="text-pink-600 font-bold tracking-[0.2em] text-sm uppercase flex items-center gap-2" data-id="element-90">
            ⭐ Aula Mater ⭐
          </span>
        </div>

        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-92">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-navy-900 leading-[1.1] tracking-tight mb-6 uppercase" data-id="element-93">
              Inicio en la
              <br data-id="element-94" />
              <span className="text-pink-600" data-id="element-95">Psicopedagogía Clínica</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-700 font-semibold mb-3 max-w-2xl mx-auto" data-id="element-96">
              Todo lo que necesitás saber en tus primeros pasos.
            </p>

            <p className="font-serif italic text-xl sm:text-2xl text-rose-500" data-id="element-97">
              Empezá clínica con más claridad y menos improvisación.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-md mx-auto mb-10" data-id="element-98">
          <div className="absolute inset-0 bg-gradient-to-tr from-pink-100 to-rose-50 rounded-3xl transform rotate-2 scale-[1.05] -z-10" data-id="element-99" />
          <img src="https://cdn.magicpatterns.com/uploads/eQg7PcdygVcQmx3HJ8in1v/principal.png" alt="Inicio en la Psicopedagogía Clínica — Aula Mater" className="w-full h-auto drop-shadow-2xl" data-id="element-100" />
        </motion.div>

        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-101">
          <p className="text-base sm:text-lg text-slate-600 mb-6" data-id="element-102">
            Todo el material organizado para ayudarte a sentirte más segura en{' '}
            <span className="font-semibold text-navy-900" data-id="element-103">
              entrevistas, evaluaciones, intervenciones e informes.
            </span>
          </p>

          <div className="bg-white/70 backdrop-blur-sm border border-slate-100 rounded-2xl p-5 mb-8 shadow-sm" data-id="element-104">
            <p className="font-bold text-navy-900 mb-4 text-sm tracking-widest uppercase" data-id="element-105">
              👉 Acceso inmediato y organizado
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm" data-id="element-106">
              {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material completo', 'Descargás y usás cuando quieras'].map((t, i) => <div key={i} className="flex items-start gap-2" data-id="element-107">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-108" />
                  <span className="text-slate-700 font-medium text-left" data-id="element-109">
                    {t}
                  </span>
                </div>)}
            </div>
          </div>

          <CTA scrollTo="oferta" label="QUIERO EMPEZAR CON MÁS SEGURIDAD" data-id="element-110" />
        </div>
      </div>
    </section>;
}